import { render, staticRenderFns } from "./orderProductBom.vue?vue&type=template&id=78e852e0&scoped=true"
import script from "./orderProductBom.vue?vue&type=script&lang=js"
export * from "./orderProductBom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e852e0",
  null
  
)

export default component.exports